import React, { useState } from "react";
import { Dropdown, Form, Row, Col } from "react-bootstrap";
import {
  ProgramDropdown,
  BrandDropdown,
  BussinesModelDropdown,
  GeographiesDropdown,
  LanguagesDropdown,
} from "CommonDropdowns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  const [show, setShow] = useState(false);
  const [programValue, setProgramValue] = useState(null);
  const [brandValue, setBrandValue] = useState(null);
  const [languageValue, setLanguageValue] = useState(null);
  const [businessModelValue, setBusinessModelValue] = useState(null);
  const [geographyValue, setGeographyValue] = useState(null);

  const handleToggle = (isOpen) => {
    setShow(isOpen);
  };

  const handleReset = () => {
    setExtraFiltersState({
      ...extraFiltersState,
      values: {
        start_period: null,
        end_period: null,
        program_id: null,
        brand_id: null,
        language_id: null,
        business_model_id: null,
        geography_id: null,
      },
    });
    setProgramValue(null);
    setBrandValue(null);
    setLanguageValue(null);
    setBusinessModelValue(null);
    setGeographyValue(null);
    onFilter();
    setShow(false);
  };

  const handleSearch = () => {
    onFilter();
    setShow(false);
  };

  const handleCancel = () => {
    setShow(false);
  };

  const handleInputChange = (name, value) => {
    setExtraFiltersState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [name]: value,
      },
    }));
  };

  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programId = selected ? selected.value : null;
    
    handleInputChange("program_id", programId);
    // Reset brand when program changes
    setBrandValue(null);
    handleInputChange("brand_id", null);
  };

  const handleBrandChange = (selected) => {
    setBrandValue(selected);
    const brandId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("brand_id", brandId);
  };

  const handleLanguageChange = (selected) => {
    setLanguageValue(selected);
    const languageId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("language_id", languageId);
  };

  const handleBusinessModelChange = (selected) => {
    setBusinessModelValue(selected);
    const businessModelId = selected
      ? selected.map((item) => item.value)
      : null;
    handleInputChange("business_model_id", businessModelId);
  };

  const handleGeographyChange = (selected) => {
    setGeographyValue(selected);
    const geographyId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("geography_id", geographyId);
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Start Period</Form.Label>
              <DatePicker
                selected={extraFiltersState.values.start_period}
                onChange={(date) => {
                  if (date) {
                    const newDate = new Date(date.getFullYear(), date.getMonth(), 1);
                    handleInputChange("start_period", newDate);
                  } else {
                    handleInputChange("start_period", null);
                  }
                }}
                selectsStart
                startDate={extraFiltersState.values.start_period}
                endDate={extraFiltersState.values.end_period}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                placeholderText="Start Month"
                className="input-field ps-2"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">End Period</Form.Label>
              <DatePicker
                selected={extraFiltersState.values.end_period}
                onChange={(date) => handleInputChange("end_period", date)}
                selectsEnd
                startDate={extraFiltersState.values.start_period}
                endDate={extraFiltersState.values.end_period}
                minDate={extraFiltersState.values.start_period}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                placeholderText="End Month"
                className="input-field ps-2"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <ProgramDropdown
                programValue={programValue}
                setProgramValue={setProgramValue}
                isMulti={false}
                showAll={false}
                selectedId={extraFiltersState.values.program_id}
                programOnChange={handleProgramChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <BrandDropdown
                value={brandValue}
                setValue={setBrandValue}
                onChange={handleBrandChange}
                isMulti={true}
                program_id={extraFiltersState.values.program_id}
                selectedId={extraFiltersState.values.brand_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <LanguagesDropdown
                value={languageValue}
                setValue={setLanguageValue}
                onChange={handleLanguageChange}
                isMulti={true}
                selectedId={extraFiltersState.values.language_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <BussinesModelDropdown
                value={businessModelValue}
                setValue={setBusinessModelValue}
                onChange={handleBusinessModelChange}
                isMulti={true}
                selectedId={extraFiltersState.values.business_model_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <GeographiesDropdown
                value={geographyValue}
                setValue={setGeographyValue}
                onChange={handleGeographyChange}
                isMulti={true}
                selectedId={extraFiltersState.values.geography_id}
              />
            </Form.Group>
          </Col>
          <Col className="d-flex align-items-center gap-2">
            
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn mb-3"
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
              />
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="refresh-btn"
            >
              <img src="/assets/images/refresh-icon.svg" alt="" />
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
